import { apiRequest } from "../util/apiUtils";

export const orderReportList = async (params) => {
  try {
    const res = await apiRequest("get", `reporting/order-list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const saleLReportist = async (params) => {
  try {
    const res = await apiRequest("get", `reporting/sales-list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const reportExportsList = async (params) => {
  try {
    const res = await apiRequest("get", `reporting/export/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const exportReports = async (params) => {
  try {
    const res = await apiRequest(
      "post",
      `reporting/export`,
      {
        body: params,
      },
      "multipart/form-data"
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};
